import { FC } from 'react';
import { Button, Typography } from 'antd';

import { ModalComponent } from 'componets/common';

import { ModalProps } from 'models';
import { useTranslate } from 'hooks';

interface NotifyNewslettersModalProps extends ModalProps {
	onCancel: () => void;
}

export const CreateAccountNotifyNewsletter: FC<NotifyNewslettersModalProps> = ({
	isOpen,
	onClose,
	onCancel,
}) => {
	const { receiveInfoCancelText, yesText, cancelText, optOutText } = useTranslate([
		'receiveInfoCancelText',
		'yesText',
		'cancelText',
		'optOutText',
	]);

	return (
		<ModalComponent isOpen={isOpen} onClose={onClose} title={optOutText}>
			<div className="modal-content">
				<Typography.Text>{receiveInfoCancelText}</Typography.Text>
				<div className="modal-footer">
					<Button onClick={onCancel} type="primary">
						{yesText}
					</Button>
					<Button onClick={onClose}>{cancelText}</Button>
				</div>
			</div>
		</ModalComponent>
	);
};
